import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import useWebData from '../../hooks/useWebData';
import { getFaqs } from '../../services/faq';
import DOMPurify from 'dompurify';
import { tenantId } from '../../config/api';
import { Helmet } from 'react-helmet-async';

function Faq() {
    const [faqData, setFaqData] = useState<any[]>([]);
    const { webData }: any = useWebData();

    document.title = webData?.companyName + " | FAQ";

    useEffect(() => {
        getFaqs(tenantId)
            .then(data => {
                const result = data.map((item: any) => {
                    return {
                        ...item,
                        answer: DOMPurify.sanitize(item.answer)
                    }
                })
                setFaqData(result)
            })
            .catch(error => console.error('Error fetching FAQ data:', error));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Helmet>
                <title>Vehicle & Van Rental Questions Answered | FAQs</title>
                <meta
                    name="description"
                    content="Find answers to common questions about our vehicle and van rental services, booking process, pricing, policies, and rental requirements."
                />
            </Helmet>

            <div className='mt-[130px]'>
                <section
                    style={{ backgroundImage: `url('${webData?.websiteSubPageImage ? webData?.websiteSubPageImage : ""}')` }}
                    className="relative faq-container flex flex-col justify-center w-full h-[200px] bg-no-repeat bg-cover bg-center">
                    <div className="absolute inset-0 bg-black bg-opacity-40" />
                    <div className='w-full text-center absolute'>
                        <h1 className="text-center text-white text-2xl font-bold">FAQ</h1>
                        <p className="text-center text-white text-sm sm:text-md md:text-xl">See frequently asked questions about our services</p>
                    </div>

                </section>

                <div className="grid gap-5 grid-cols-1 md:grid-cols-2 p-8 md:p-10">
                    {faqData.map((item) => (
                        <div
                            key={item.id}
                            className="w-full rounded-md p-5 mb-5 border border-cyan-200 transition ease-in-out delay-100 hover:shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                            style={{ borderColor: webData?.websiteHeaderColor }}
                        >
                            <h3 className="text-lg font-bold pb-2">
                                <FontAwesomeIcon
                                    icon={faQuestion}
                                    className="text-white text-base p-2 rounded-full w-4 h-4 mr-2.5 align-middle"
                                    style={{ backgroundColor: webData?.websiteHeaderColor ? webData?.websiteHeaderColor : "green" }} />

                                {item.question}</h3>
                            <p className='text-base' dangerouslySetInnerHTML={{ __html: item.answer }} />
                        </div>
                    ))}
                </div>
            </div>
        </>

    );
}
export default Faq;